export enum DependencyActionEnum {
	ENABLE = 'enable',
	ENABLE_CODE = 'enable_code',
	DISABLE = 'disable',
	CODE = 'execute',
	LOCK = 'lock'
}
